import React from 'react'
// components
import Table, {
  TableProps
} from 'components/PageComponents/RiskTemplates/Edit/components/RiskTemplateFields/components/Table'
// layers
import RiskTableProvider from './layers/BL'

const RiskTableContainer: React.FC<TableProps> = (props) => (
  <RiskTableProvider field={props.field}>
    <Table {...props} />
  </RiskTableProvider>
)

export default RiskTableContainer
